//TODO: change it to use date-fns instead
import { HighlightsDuration } from '../../types';

export const formatDuration = (duration: HighlightsDuration): string => {
  const parts = [];

  if (duration.days > 0) parts.push(`${duration.days} day${duration.days > 1 ? 's' : ''}`);
  if (duration.hours > 0) parts.push(`${duration.hours} hour${duration.hours > 1 ? 's' : ''}`);
  if (duration.minutes > 0) parts.push(`${duration.minutes} minute${duration.minutes > 1 ? 's' : ''}`);

  return parts.length > 0 ? parts.join(', ') : '0 minutes';
};
